import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";

let priorityList = [];
let notified = false;

const AppPriorities = () => {
	const [appPriority, setAppPriority] = useState(priorityList);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        getPriorityList();
    }, []);

    const getPriorityList = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/settings/status', config);
            priorityList = resp.data.priorityList;
            setAppPriority(priorityList);
        } catch(err) {
            toast.error('API error getting priority list, please refresh the page');
        }
    };

    const savePriorities = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        let body = [
            priorityList[0], 
            priorityList[1], 
            priorityList[2], 
            priorityList[3]
        ];
        
        try {
            setIsSaving(true);
            const resp = await api.post("/settings/priorities", { priorityList: body}, config);

            if (resp.status !== 200) {
                toast.error("API error updating priority list");
            } else {
                toast.success('Successfully updated priority list');
            }
        } catch(err) {
            toast.error('API error updating priority list');
        } finally {
            setIsSaving(false);
        }

    };

	const handleOnDragEnd = (result) => {
		if (!result.destination) return;

		const items = Array.from(appPriority);
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);

        priorityList = items;
		setAppPriority(priorityList);
	};

    const notifyOptimization = async (id) => {
        if (notified) {
            return;
        }

        const body = {appliance_id: id};
        notified = true;

        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.post('/settings/notify-optimization', body, config);

            if (resp.status !== 200) {
                toast.error("API Error updating appliances notification status.");
            }
            
        } catch {
            toast.error('Error updating appliances notification status.');
            notified = true;
        }
    };

    const getStyle = (id, optimized, toNotify) => {
        if (!toNotify) {
            return '';
        }

        notifyOptimization(id);

        if (optimized) {            
            return "green-priority";
        }

        if (!optimized) {
            return "red-priority";
        }
    };

    const renderDragNDrop = () => {
        if (appPriority.length === 0) {
            return 'NA';
        }

        return (
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="priorities">
                    {(provided) => (
                        <ul
                            className="priorities"
                            style={{paddingLeft: "0px"}}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {appPriority.map(({ id, name, optimized, toNotify }, index) => {
                                return (
                                    <Draggable key={id} draggableId={id} index={index}>
                                        {(provided) => (
                                            <li
                                                className={`appItem list-group-item ${getStyle(id, optimized, toNotify)}`}
                                                // style={getStyle(optimized)}
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <p>{name}</p>
                                            </li>
                                        )}
                                    </Draggable>
                                );
                            })}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>
        );
    };

	return (
		<div id="place_for_priorityList" className="demo-container">
            <div id="priorityList" className="priorityList-list-group">
                { renderDragNDrop() }
            </div>
            <button onClick={savePriorities} type="button" className="btn btn-primary settings-save-button" disabled={isSaving}>
                {isSaving ? "Saving…" : "Save changes"}
            </button>
		</div>
	);
};

export default AppPriorities;
